<ng-container *ngIf="viewContextEntrypoint$ | async as entrypoint">
  <ish-content-pagelet *ngFor="let pagelet of entrypoint.pageletIDs" [pageletId]="pagelet" />
</ng-container>
